var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconColumnLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-9 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-9 {\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: 0.33px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-width: 0.22px;\r\n      }\r\n\r\n      .cls-5 {\r\n        stroke-width: 1.33px;\r\n      }\r\n\r\n      .cls-6 {\r\n        stroke-width: 0.47px;\r\n      }\r\n\r\n      .cls-7 {\r\n        stroke-width: 0.8px;\r\n      }\r\n\r\n      .cls-8 {\r\n        font-size: 8.79px;\r\n        font-family: ArialMT, Arial;\r\n      }\r\n\r\n      .cls-9 {\r\n        stroke-width: 0.64px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconColumnLayer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Boundary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 256,
    height: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Column"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.71 140.16 77.54 138.85 77.54 55.95 72.71 57.28 72.71 60.64 72.71 140.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.71 140.16 72.69 57.27 69.63 55.23 69.63 138.1 72.69 140.14 72.71 140.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.71,
    y1: 140.16,
    x2: 75.77,
    y2: 139.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.77,
    y1: 139.33,
    x2: 72.71,
    y2: 140.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.69,
    y1: 140.14,
    x2: 69.63,
    y2: 138.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.86,
    y1: 138.58,
    x2: 69.61,
    y2: 138.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.69,
    y1: 140.14,
    x2: 67.86,
    y2: 136.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 69.63,
    y1: 58.1,
    x2: 69.63,
    y2: 138.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 77.54,
    y1: 138.85,
    x2: 78.66,
    y2: 139.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 79.5,
    y1: 140.16,
    x2: 80.62,
    y2: 140.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 57.28,
    x2: 72.71,
    y2: 58.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 59.86,
    x2: 72.71,
    y2: 61.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 63.16,
    x2: 72.71,
    y2: 65.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 66.46,
    x2: 72.71,
    y2: 68.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 69.75,
    x2: 72.71,
    y2: 71.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 73.05,
    x2: 72.71,
    y2: 74.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 76.35,
    x2: 72.71,
    y2: 78.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 79.64,
    x2: 72.71,
    y2: 81.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 82.94,
    x2: 72.71,
    y2: 84.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 86.24,
    x2: 72.71,
    y2: 88.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 89.54,
    x2: 72.71,
    y2: 91.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 92.83,
    x2: 72.71,
    y2: 94.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 96.13,
    x2: 72.71,
    y2: 98.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 99.43,
    x2: 72.71,
    y2: 101.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 102.72,
    x2: 72.71,
    y2: 104.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 106.02,
    x2: 72.71,
    y2: 107.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 109.32,
    x2: 72.71,
    y2: 111.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 112.62,
    x2: 72.71,
    y2: 114.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 115.91,
    x2: 72.71,
    y2: 117.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 119.21,
    x2: 72.71,
    y2: 121.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 122.51,
    x2: 72.71,
    y2: 124.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 125.8,
    x2: 72.71,
    y2: 127.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 129.1,
    x2: 72.71,
    y2: 130.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 132.4,
    x2: 72.71,
    y2: 134.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 135.7,
    x2: 72.71,
    y2: 137.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 138.99,
    x2: 72.71,
    y2: 140.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 139.42,
    x2: 65.66,
    y2: 139.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 66.98,
    y1: 138.82,
    x2: 67.86,
    y2: 138.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.71,
    y1: 57.28,
    x2: 72.71,
    y2: 140.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.77,
    y1: 142.2,
    x2: 72.71,
    y2: 140.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.54,
    y1: 138.85,
    x2: 77.54,
    y2: 55.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 69.63,
    y1: 55.22,
    x2: 69.63,
    y2: 58.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.86,
    y1: 136.92,
    x2: 64.78,
    y2: 134.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 67.86,
    y1: 141.48,
    x2: 72.71,
    y2: 140.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.54,
    y1: 138.85,
    x2: 75.79,
    y2: 139.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 75.79,
    y1: 139.32,
    x2: 80.62,
    y2: 138.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.5,
    y1: 71.85,
    x2: 77.62,
    y2: 70.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.62,
    y1: 70.6,
    x2: 77.62,
    y2: 56.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.62,
    y1: 56.48,
    x2: 79.5,
    y2: 57.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.5,
    y1: 57.73,
    x2: 79.5,
    y2: 57.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.54,
    y1: 71.02,
    x2: 79.5,
    y2: 72.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.5,
    y1: 72.33,
    x2: 79.5,
    y2: 71.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.5,
    y1: 71.85,
    x2: 80.62,
    y2: 71.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.62,
    y1: 69.79,
    x2: 77.62,
    y2: 70.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.01,
    y1: 57.6,
    x2: 79.5,
    y2: 57.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.62,
    y1: 72.03,
    x2: 79.5,
    y2: 72.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.08,
    y1: 109.81,
    x2: 80.62,
    y2: 109.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.54,
    y1: 55.95,
    x2: 72.71,
    y2: 57.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 140.9,
    x2: 78.86,
    y2: 141.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 77.55,
    y1: 141.74,
    x2: 75.79,
    y2: 142.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 140.9,
    x2: 80.62,
    y2: 139.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 138.31,
    x2: 80.62,
    y2: 136.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 135.02,
    x2: 80.62,
    y2: 133.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 131.72,
    x2: 80.62,
    y2: 129.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 128.42,
    x2: 80.62,
    y2: 126.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 125.13,
    x2: 80.62,
    y2: 123.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 121.83,
    x2: 80.62,
    y2: 119.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 118.53,
    x2: 80.62,
    y2: 116.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 115.23,
    x2: 80.62,
    y2: 113.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 111.94,
    x2: 80.62,
    y2: 110.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 108.64,
    x2: 80.62,
    y2: 106.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 105.34,
    x2: 80.62,
    y2: 103.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 102.05,
    x2: 80.62,
    y2: 100.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 98.75,
    x2: 80.62,
    y2: 96.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 95.45,
    x2: 80.62,
    y2: 93.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 92.15,
    x2: 80.62,
    y2: 90.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 88.86,
    x2: 80.62,
    y2: 86.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 85.56,
    x2: 80.62,
    y2: 83.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 82.26,
    x2: 80.62,
    y2: 80.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 78.97,
    x2: 80.62,
    y2: 77.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 75.67,
    x2: 80.62,
    y2: 73.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 72.37,
    x2: 80.62,
    y2: 70.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 69.07,
    x2: 80.62,
    y2: 67.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 65.78,
    x2: 80.62,
    y2: 63.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 62.48,
    x2: 80.62,
    y2: 60.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 59.18,
    x2: 80.62,
    y2: 58.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 77.54,
    y1: 55.95,
    x2: 78.66,
    y2: 56.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 79.5,
    y1: 57.26,
    x2: 80.62,
    y2: 58.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.71,
    y1: 57.26,
    x2: 74.47,
    y2: 56.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.78,
    y1: 56.43,
    x2: 77.54,
    y2: 55.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 80.62,
    y1: 58.01,
    x2: 78.86,
    y2: 58.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 77.55,
    y1: 58.84,
    x2: 75.79,
    y2: 59.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.86,
    y1: 141.48,
    x2: 66.74,
    y2: 140.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 65.9,
    y1: 140.17,
    x2: 64.78,
    y2: 139.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 56.52,
    x2: 64.78,
    y2: 57.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 59.11,
    x2: 64.78,
    y2: 61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 62.41,
    x2: 64.78,
    y2: 64.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 65.71,
    x2: 64.78,
    y2: 67.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 69,
    x2: 64.78,
    y2: 70.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 72.3,
    x2: 64.78,
    y2: 74.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 75.6,
    x2: 64.78,
    y2: 77.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 78.9,
    x2: 64.78,
    y2: 80.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 82.19,
    x2: 64.78,
    y2: 84.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 85.49,
    x2: 64.78,
    y2: 87.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 88.79,
    x2: 64.78,
    y2: 90.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 92.08,
    x2: 64.78,
    y2: 93.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 95.38,
    x2: 64.78,
    y2: 97.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 98.68,
    x2: 64.78,
    y2: 100.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 101.98,
    x2: 64.78,
    y2: 103.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 105.27,
    x2: 64.78,
    y2: 107.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 108.57,
    x2: 64.78,
    y2: 110.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 111.87,
    x2: 64.78,
    y2: 113.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 115.16,
    x2: 64.78,
    y2: 117.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 118.46,
    x2: 64.78,
    y2: 120.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 121.76,
    x2: 64.78,
    y2: 123.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 125.05,
    x2: 64.78,
    y2: 126.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 128.35,
    x2: 64.78,
    y2: 130.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 131.65,
    x2: 64.78,
    y2: 133.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 134.95,
    x2: 64.78,
    y2: 136.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 138.24,
    x2: 64.78,
    y2: 139.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 69.61,
    y1: 55.21,
    x2: 70.73,
    y2: 55.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 71.57,
    y1: 56.52,
    x2: 72.69,
    y2: 57.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 64.78,
    y1: 56.52,
    x2: 66.53,
    y2: 56.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.85,
    y1: 55.69,
    x2: 69.61,
    y2: 55.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 67.86,
    y1: 58.58,
    x2: 66.74,
    y2: 57.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 65.9,
    y1: 57.27,
    x2: 64.78,
    y2: 56.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.77,
    y1: 142.22,
    x2: 74.01,
    y2: 142.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.7,
    y1: 143.06,
    x2: 70.94,
    y2: 143.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 143.54,
    x2: 69.82,
    y2: 142.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 68.98,
    y1: 142.23,
    x2: 67.86,
    y2: 141.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 60.64,
    x2: 70.94,
    y2: 61.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 63.23,
    x2: 70.94,
    y2: 65.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 66.53,
    x2: 70.94,
    y2: 68.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 69.82,
    x2: 70.94,
    y2: 71.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 73.12,
    x2: 70.94,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 76.42,
    x2: 70.94,
    y2: 78.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 79.71,
    x2: 70.94,
    y2: 81.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 83.01,
    x2: 70.94,
    y2: 84.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 86.31,
    x2: 70.94,
    y2: 88.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 89.61,
    x2: 70.94,
    y2: 91.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 92.9,
    x2: 70.94,
    y2: 94.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 96.2,
    x2: 70.94,
    y2: 98.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 99.5,
    x2: 70.94,
    y2: 101.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 102.79,
    x2: 70.94,
    y2: 104.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 106.09,
    x2: 70.94,
    y2: 107.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 109.39,
    x2: 70.94,
    y2: 111.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 112.69,
    x2: 70.94,
    y2: 114.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 115.98,
    x2: 70.94,
    y2: 117.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 119.28,
    x2: 70.94,
    y2: 121.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 122.58,
    x2: 70.94,
    y2: 124.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 125.87,
    x2: 70.94,
    y2: 127.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 129.17,
    x2: 70.94,
    y2: 131.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 132.47,
    x2: 70.94,
    y2: 134.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 135.76,
    x2: 70.94,
    y2: 137.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 139.06,
    x2: 70.94,
    y2: 140.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 142.36,
    x2: 70.94,
    y2: 143.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 70.94,
    y1: 60.64,
    x2: 69.82,
    y2: 59.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 68.98,
    y1: 59.33,
    x2: 67.86,
    y2: 58.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 75.77,
    y1: 59.33,
    x2: 74.01,
    y2: 59.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 72.7,
    y1: 60.16,
    x2: 70.94,
    y2: 60.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.85,
    y1: 40.15,
    x2: 72.69,
    y2: 51.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.69,
    y1: 51.62,
    x2: 42.44,
    y2: 31.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.44,
    y1: 29.53,
    x2: 72.69,
    y2: 49.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.69,
    y1: 49.73,
    x2: 114.85,
    y2: 38.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.85,
    y1: 38.27,
    x2: 84.6,
    y2: 18.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 84.6,
    y1: 18.06,
    x2: 42.44,
    y2: 29.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.44,
    y1: 31.41,
    x2: 42.44,
    y2: 29.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.85,
    y1: 38.27,
    x2: 114.85,
    y2: 40.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.69,
    y1: 49.73,
    x2: 72.69,
    y2: 51.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.85,
    y1: 45.8,
    x2: 72.71,
    y2: 57.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.69,
    y1: 57.27,
    x2: 42.44,
    y2: 37.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.44,
    y1: 31.41,
    x2: 72.69,
    y2: 51.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.69,
    y1: 51.62,
    x2: 114.85,
    y2: 40.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.44,
    y1: 37.06,
    x2: 42.44,
    y2: 31.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.85,
    y1: 40.15,
    x2: 114.85,
    y2: 45.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 72.69,
    y1: 51.62,
    x2: 72.69,
    y2: 57.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 92.32,
    y1: 153.25,
    x2: 75.79,
    y2: 142.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 64.78,
    y1: 134.86,
    x2: 57.54,
    y2: 130.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 55.3,
    y1: 128.53,
    x2: 51.94,
    y2: 126.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 49.7,
    y1: 124.79,
    x2: 42.46,
    y2: 119.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 44.62,
    y1: 147.8,
    x2: 67.86,
    y2: 141.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.62,
    y1: 138.01,
    x2: 98.28,
    y2: 133.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 101.79,
    y1: 132.25,
    x2: 107.06,
    y2: 130.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.57,
    y1: 129.86,
    x2: 128.24,
    y2: 125.06
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "102.4 159.99 104.27 159.32 105.67 158.46 106.51 157.48 106.72 156.44 106.29 155.42 105.26 154.47 103.68 153.68 101.68 153.08 99.38 152.72 96.94 152.63 94.53 152.81 92.32 153.25 90.44 153.93 89.04 154.78 88.21 155.76 87.99 156.8 88.42 157.83 89.46 158.77 91.03 159.57 93.03 160.17 95.33 160.52 97.77 160.61 100.18 160.43 102.4 159.99"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "41.76 153.31 43.63 152.64 45.03 151.79 45.87 150.81 46.08 149.77 45.66 148.74 44.62 147.8 43.05 147 41.04 146.4 38.74 146.05 36.3 145.96 33.89 146.14 31.68 146.58 29.8 147.25 28.4 148.11 27.57 149.09 27.36 150.13 27.78 151.15 28.82 152.1 30.39 152.9 32.4 153.49 34.7 153.85 37.13 153.94 39.54 153.76 41.76 153.31"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 79.5,
    y1: 57.26,
    x2: 77.54,
    y2: 55.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.81,
    y1: 61.71,
    x2: 116.81,
    y2: 62.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.85,
    y1: 45.8,
    x2: 116.81,
    y2: 47.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.81,
    y1: 47.11,
    x2: 116.81,
    y2: 47.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.93,
    y1: 48.1,
    x2: 114.93,
    y2: 60.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.93,
    y1: 60.46,
    x2: 116.81,
    y2: 61.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.62,
    y1: 71.55,
    x2: 116.81,
    y2: 61.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.93,
    y1: 60.46,
    x2: 80.62,
    y2: 69.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.81,
    y1: 47.59,
    x2: 80.01,
    y2: 57.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.81,
    y1: 47.11,
    x2: 79.5,
    y2: 57.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.81,
    y1: 62.18,
    x2: 80.62,
    y2: 72.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 80.62,
    y1: 109.39,
    x2: 82.48,
    y2: 108.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 84.24,
    y1: 108.41,
    x2: 87.75,
    y2: 107.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 89.5,
    y1: 106.98,
    x2: 93.02,
    y2: 106.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 94.77,
    y1: 105.55,
    x2: 98.28,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100.04,
    y1: 104.11,
    x2: 103.55,
    y2: 103.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 105.31,
    y1: 102.68,
    x2: 108.82,
    y2: 101.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.57,
    y1: 101.25,
    x2: 114.08,
    y2: 100.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 115.84,
    y1: 99.82,
    x2: 119.35,
    y2: 98.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.11,
    y1: 98.38,
    x2: 124.62,
    y2: 97.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 126.37,
    y1: 96.95,
    x2: 128.24,
    y2: 96.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.6,
    y1: 60.4,
    x2: 118.91,
    y2: 59.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120.66,
    y1: 59.29,
    x2: 124.18,
    y2: 58.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.93,
    y1: 57.86,
    x2: 128.24,
    y2: 57.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.6,
    y1: 45.32,
    x2: 118.91,
    y2: 44.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120.66,
    y1: 44.22,
    x2: 124.18,
    y2: 43.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.93,
    y1: 42.79,
    x2: 128.24,
    y2: 42.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 116.6,
    y1: 37.79,
    x2: 118.91,
    y2: 37.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 120.66,
    y1: 36.68,
    x2: 124.18,
    y2: 35.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 125.93,
    y1: 35.25,
    x2: 128.24,
    y2: 34.62
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "128.24 34.15 127.86 34.49 127.86 34.96 128.24 35.1 128.62 34.76 128.62 34.29 128.24 34.15"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "128.24 41.69 127.86 42.03 127.86 42.5 128.24 42.63 128.62 42.29 128.62 41.82 128.24 41.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "128.24 56.76 127.86 57.1 127.86 57.57 128.24 57.7 128.62 57.37 128.62 56.89 128.24 56.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 117.42,
    y1: 131.77,
    x2: 117.42,
    y2: 95.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 117.42,
    y1: 99.38,
    x2: 119.18,
    y2: 100.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 117.42,
    y1: 99.38,
    x2: 115.67,
    y2: 97.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 117.42,
    y1: 99.38,
    x2: 113.91,
    y2: 100.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 117.42,
    y1: 99.38,
    x2: 118.45,
    y2: 99.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 117.42,
    y1: 128,
    x2: 119.18,
    y2: 129.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 117.42,
    y1: 128,
    x2: 115.67,
    y2: 126.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 117.42,
    y1: 128,
    x2: 113.91,
    y2: 128.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 117.42,
    y1: 128,
    x2: 118.45,
    y2: 127.72
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.24 111.69 116.54 112.43 117.28 112.73 118.02 112.43 118.32 111.69 118.02 110.96 117.28 110.65 116.54 110.96 116.24 111.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "116.24 111.69 116.54 112.43 117.28 112.73 118.02 112.43 118.32 111.69 118.02 110.96 117.28 110.65 116.54 110.96 116.24 111.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "116.24 111.69 116.54 112.43 117.28 112.73 118.02 112.43 118.32 111.69 118.02 110.96 117.28 110.65 116.54 110.96 116.24 111.69"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 117.28,
    y1: 111.69,
    x2: 130.47,
    y2: 111.69
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(133.59 114.82)"
  }, "Custom Height"), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(133.59 61.78)"
  }, "Bottom of framing"), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(133.59 46.76)"
  }, "Top of framing"), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(133.59 35.66)"
  }, "Top of module"), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(25.97 179.37)"
  }, "Note: Only 1/4 of each column will count toward GWP. "), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(25.97 189.44)"
  }, "It is assumed that the module will repeat adjacent."), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(133.59 23.17)"
  }, "Column Height options:"), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 133.59,
    y1: 24.12,
    x2: 224.98,
    y2: 24.12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColumnLayer);
export default __webpack_public_path__ + "static/media/IconColumnLayer.f612277223a816aa0cf387f8d8f88b99.svg";
export { ForwardRef as ReactComponent };